export const dishes = [
    '3612',
    '738',
    '5464',
    '5486',
];

export const periods = [
    '2026-07-27',
    '2026-08-03',
    '2026-08-10',
];
